export type Json =
  | string
  | number
  | boolean
  | null
  | { [key: string]: Json | undefined }
  | Json[]

export type Database = {
  public: {
    Tables: {
      address_connections: {
        Row: {
          address_id: string
          asset_id: string
          created_at: string
          data: Json | null
          id: string
          relation_type:
            | Database["public"]["Enums"]["address_relation_type"]
            | null
          updated_at: string
        }
        Insert: {
          address_id: string
          asset_id: string
          created_at?: string
          data?: Json | null
          id?: string
          relation_type?:
            | Database["public"]["Enums"]["address_relation_type"]
            | null
          updated_at?: string
        }
        Update: {
          address_id?: string
          asset_id?: string
          created_at?: string
          data?: Json | null
          id?: string
          relation_type?:
            | Database["public"]["Enums"]["address_relation_type"]
            | null
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "address_connections_address_id_fkey"
            columns: ["address_id"]
            isOneToOne: false
            referencedRelation: "addresses"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "address_connections_address_id_fkey"
            columns: ["address_id"]
            isOneToOne: false
            referencedRelation: "asset_addresses"
            referencedColumns: ["address_id"]
          },
          {
            foreignKeyName: "address_connections_asset_id_fkey"
            columns: ["asset_id"]
            isOneToOne: false
            referencedRelation: "asset_addresses"
            referencedColumns: ["asset_id"]
          },
          {
            foreignKeyName: "address_connections_asset_id_fkey"
            columns: ["asset_id"]
            isOneToOne: false
            referencedRelation: "asset_traits"
            referencedColumns: ["asset_id"]
          },
          {
            foreignKeyName: "address_connections_asset_id_fkey"
            columns: ["asset_id"]
            isOneToOne: false
            referencedRelation: "assets"
            referencedColumns: ["id"]
          },
        ]
      }
      addresses: {
        Row: {
          address: Json
          address_hash: string | null
          address_type: string
          country: string
          created_at: string
          data: Json | null
          geom: unknown
          id: string
          postal_code: string
          updated_at: string
        }
        Insert: {
          address: Json
          address_hash?: string | null
          address_type?: string
          country: string
          created_at?: string
          data?: Json | null
          geom?: unknown
          id?: string
          postal_code: string
          updated_at?: string
        }
        Update: {
          address?: Json
          address_hash?: string | null
          address_type?: string
          country?: string
          created_at?: string
          data?: Json | null
          geom?: unknown
          id?: string
          postal_code?: string
          updated_at?: string
        }
        Relationships: []
      }
      asset_prices: {
        Row: {
          asset_id: string
          created_at: string
          currency: string
          deleted_at: string | null
          id: string
          price: number
          price_type: Database["public"]["Enums"]["asset_price_type"]
          user_id: string | null
        }
        Insert: {
          asset_id: string
          created_at?: string
          currency?: string
          deleted_at?: string | null
          id?: string
          price: number
          price_type?: Database["public"]["Enums"]["asset_price_type"]
          user_id?: string | null
        }
        Update: {
          asset_id?: string
          created_at?: string
          currency?: string
          deleted_at?: string | null
          id?: string
          price?: number
          price_type?: Database["public"]["Enums"]["asset_price_type"]
          user_id?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "asset_prices_asset_id_fkey"
            columns: ["asset_id"]
            isOneToOne: false
            referencedRelation: "asset_addresses"
            referencedColumns: ["asset_id"]
          },
          {
            foreignKeyName: "asset_prices_asset_id_fkey"
            columns: ["asset_id"]
            isOneToOne: false
            referencedRelation: "asset_traits"
            referencedColumns: ["asset_id"]
          },
          {
            foreignKeyName: "asset_prices_asset_id_fkey"
            columns: ["asset_id"]
            isOneToOne: false
            referencedRelation: "assets"
            referencedColumns: ["id"]
          },
        ]
      }
      assets: {
        Row: {
          created_at: string
          data: Json | null
          deleted_at: string | null
          description: string | null
          embedding: string | null
          feedback_settings: Json | null
          id: string
          media: Json | null
          name: string
          order: number
          source: Json | null
          updated_at: string
        }
        Insert: {
          created_at?: string
          data?: Json | null
          deleted_at?: string | null
          description?: string | null
          embedding?: string | null
          feedback_settings?: Json | null
          id?: string
          media?: Json | null
          name: string
          order?: number
          source?: Json | null
          updated_at?: string
        }
        Update: {
          created_at?: string
          data?: Json | null
          deleted_at?: string | null
          description?: string | null
          embedding?: string | null
          feedback_settings?: Json | null
          id?: string
          media?: Json | null
          name?: string
          order?: number
          source?: Json | null
          updated_at?: string
        }
        Relationships: []
      }
      contact_requests: {
        Row: {
          asset_id: string | null
          contact_id: string | null
          created_at: string
          deleted_at: string | null
          id: string
          lead_owner_user_id: string | null
          purchased_contact_id: string | null
          responded_at: string | null
          responder_user_id: string | null
          sent_at: string | null
          short_id: string
          status: Database["public"]["Enums"]["contact_request_status"]
          updated_at: string
          user_id: string | null
        }
        Insert: {
          asset_id?: string | null
          contact_id?: string | null
          created_at?: string
          deleted_at?: string | null
          id?: string
          lead_owner_user_id?: string | null
          purchased_contact_id?: string | null
          responded_at?: string | null
          responder_user_id?: string | null
          sent_at?: string | null
          short_id?: string
          status?: Database["public"]["Enums"]["contact_request_status"]
          updated_at?: string
          user_id?: string | null
        }
        Update: {
          asset_id?: string | null
          contact_id?: string | null
          created_at?: string
          deleted_at?: string | null
          id?: string
          lead_owner_user_id?: string | null
          purchased_contact_id?: string | null
          responded_at?: string | null
          responder_user_id?: string | null
          sent_at?: string | null
          short_id?: string
          status?: Database["public"]["Enums"]["contact_request_status"]
          updated_at?: string
          user_id?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "contact_requests_asset_id_fkey"
            columns: ["asset_id"]
            isOneToOne: false
            referencedRelation: "asset_addresses"
            referencedColumns: ["asset_id"]
          },
          {
            foreignKeyName: "contact_requests_asset_id_fkey"
            columns: ["asset_id"]
            isOneToOne: false
            referencedRelation: "asset_traits"
            referencedColumns: ["asset_id"]
          },
          {
            foreignKeyName: "contact_requests_asset_id_fkey"
            columns: ["asset_id"]
            isOneToOne: false
            referencedRelation: "assets"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "contact_requests_contact_id_fkey"
            columns: ["contact_id"]
            isOneToOne: false
            referencedRelation: "contacts"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "contact_requests_purchased_contact_id_fkey"
            columns: ["purchased_contact_id"]
            isOneToOne: false
            referencedRelation: "contacts"
            referencedColumns: ["id"]
          },
        ]
      }
      contacts: {
        Row: {
          consent_confirmed: boolean | null
          created_at: string
          data: Json
          deleted_at: string | null
          disabled_at: string | null
          disabled_reason: string | null
          email: string | null
          id: string
          language: string
          name: string
          phone: string | null
          private_data: Json
          purchased_at: string | null
          sms_fallback_enabled: boolean
          updated_at: string
          user_id: string | null
        }
        Insert: {
          consent_confirmed?: boolean | null
          created_at?: string
          data?: Json
          deleted_at?: string | null
          disabled_at?: string | null
          disabled_reason?: string | null
          email?: string | null
          id?: string
          language?: string
          name: string
          phone?: string | null
          private_data?: Json
          purchased_at?: string | null
          sms_fallback_enabled?: boolean
          updated_at?: string
          user_id?: string | null
        }
        Update: {
          consent_confirmed?: boolean | null
          created_at?: string
          data?: Json
          deleted_at?: string | null
          disabled_at?: string | null
          disabled_reason?: string | null
          email?: string | null
          id?: string
          language?: string
          name?: string
          phone?: string | null
          private_data?: Json
          purchased_at?: string | null
          sms_fallback_enabled?: boolean
          updated_at?: string
          user_id?: string | null
        }
        Relationships: []
      }
      event_contacts: {
        Row: {
          contact_id: string
          created_at: string | null
          event_id: string
          id: string
        }
        Insert: {
          contact_id: string
          created_at?: string | null
          event_id: string
          id?: string
        }
        Update: {
          contact_id?: string
          created_at?: string | null
          event_id?: string
          id?: string
        }
        Relationships: [
          {
            foreignKeyName: "event_contacts_contact_id_fkey"
            columns: ["contact_id"]
            isOneToOne: false
            referencedRelation: "contacts"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "event_contacts_event_id_fkey"
            columns: ["event_id"]
            isOneToOne: false
            referencedRelation: "events"
            referencedColumns: ["id"]
          },
        ]
      }
      events: {
        Row: {
          asset_id: string
          created_at: string | null
          description: string | null
          event_date: string | null
          event_type: string
          id: string
          published_at: string | null
          title: string
          updated_at: string | null
          user_id: string | null
        }
        Insert: {
          asset_id: string
          created_at?: string | null
          description?: string | null
          event_date?: string | null
          event_type?: string
          id?: string
          published_at?: string | null
          title: string
          updated_at?: string | null
          user_id?: string | null
        }
        Update: {
          asset_id?: string
          created_at?: string | null
          description?: string | null
          event_date?: string | null
          event_type?: string
          id?: string
          published_at?: string | null
          title?: string
          updated_at?: string | null
          user_id?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "events_asset_id_fkey"
            columns: ["asset_id"]
            isOneToOne: false
            referencedRelation: "asset_addresses"
            referencedColumns: ["asset_id"]
          },
          {
            foreignKeyName: "events_asset_id_fkey"
            columns: ["asset_id"]
            isOneToOne: false
            referencedRelation: "asset_traits"
            referencedColumns: ["asset_id"]
          },
          {
            foreignKeyName: "events_asset_id_fkey"
            columns: ["asset_id"]
            isOneToOne: false
            referencedRelation: "assets"
            referencedColumns: ["id"]
          },
        ]
      }
      feedback: {
        Row: {
          completed_at: string | null
          contact_id: string
          created_at: string
          current_nonce: string | null
          declined_at: string | null
          deleted_at: string | null
          follow_up_enabled: boolean
          id: string
          opened_at: string | null
          responder_user_id: string | null
          send_at: string | null
          sending_method: string | null
          short_id: string
          updated_at: string
          user_id: string
        }
        Insert: {
          completed_at?: string | null
          contact_id: string
          created_at?: string
          current_nonce?: string | null
          declined_at?: string | null
          deleted_at?: string | null
          follow_up_enabled?: boolean
          id?: string
          opened_at?: string | null
          responder_user_id?: string | null
          send_at?: string | null
          sending_method?: string | null
          short_id?: string
          updated_at?: string
          user_id?: string
        }
        Update: {
          completed_at?: string | null
          contact_id?: string
          created_at?: string
          current_nonce?: string | null
          declined_at?: string | null
          deleted_at?: string | null
          follow_up_enabled?: boolean
          id?: string
          opened_at?: string | null
          responder_user_id?: string | null
          send_at?: string | null
          sending_method?: string | null
          short_id?: string
          updated_at?: string
          user_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "feedback_contact_id_fkey"
            columns: ["contact_id"]
            isOneToOne: false
            referencedRelation: "contacts"
            referencedColumns: ["id"]
          },
        ]
      }
      feedback_notifications: {
        Row: {
          contact_id: string
          contact_info: string
          created_at: string
          failure_code: string | null
          feedback_id: string
          id: string
          method: string
          sent_at: string
          status: string
          updated_at: string
          user_id: string
        }
        Insert: {
          contact_id: string
          contact_info: string
          created_at?: string
          failure_code?: string | null
          feedback_id: string
          id?: string
          method: string
          sent_at?: string
          status: string
          updated_at?: string
          user_id: string
        }
        Update: {
          contact_id?: string
          contact_info?: string
          created_at?: string
          failure_code?: string | null
          feedback_id?: string
          id?: string
          method?: string
          sent_at?: string
          status?: string
          updated_at?: string
          user_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "feedback_notifications_contact_id_fkey"
            columns: ["contact_id"]
            isOneToOne: false
            referencedRelation: "contacts"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "feedback_notifications_feedback_id_fkey"
            columns: ["feedback_id"]
            isOneToOne: false
            referencedRelation: "feedback"
            referencedColumns: ["id"]
          },
        ]
      }
      interests: {
        Row: {
          contact_id: string
          created_at: string
          data: Json
          deleted_at: string | null
          description: string | null
          embedding: string | null
          feedback_id: string | null
          id: string
          updated_at: string | null
          user_id: string | null
          verified_at: string | null
        }
        Insert: {
          contact_id: string
          created_at?: string
          data: Json
          deleted_at?: string | null
          description?: string | null
          embedding?: string | null
          feedback_id?: string | null
          id?: string
          updated_at?: string | null
          user_id?: string | null
          verified_at?: string | null
        }
        Update: {
          contact_id?: string
          created_at?: string
          data?: Json
          deleted_at?: string | null
          description?: string | null
          embedding?: string | null
          feedback_id?: string | null
          id?: string
          updated_at?: string | null
          user_id?: string | null
          verified_at?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "interests_contact_id_fkey"
            columns: ["contact_id"]
            isOneToOne: false
            referencedRelation: "contacts"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "interests_feedback_id_fkey"
            columns: ["feedback_id"]
            isOneToOne: false
            referencedRelation: "feedback"
            referencedColumns: ["id"]
          },
        ]
      }
      invoicing_details: {
        Row: {
          created_at: string | null
          deleted_at: string | null
          e_invoice_address: string
          e_invoice_operator: string
          id: string
          is_valid: boolean
          organisation_identifier: string
          organisation_name: string
          reference: string | null
          updated_at: string | null
          user_id: string
        }
        Insert: {
          created_at?: string | null
          deleted_at?: string | null
          e_invoice_address: string
          e_invoice_operator: string
          id?: string
          is_valid?: boolean
          organisation_identifier: string
          organisation_name: string
          reference?: string | null
          updated_at?: string | null
          user_id?: string
        }
        Update: {
          created_at?: string | null
          deleted_at?: string | null
          e_invoice_address?: string
          e_invoice_operator?: string
          id?: string
          is_valid?: boolean
          organisation_identifier?: string
          organisation_name?: string
          reference?: string | null
          updated_at?: string | null
          user_id?: string
        }
        Relationships: []
      }
      organisations: {
        Row: {
          created_at: string
          email_domain: string
          id: string
          logo_media: Json | null
          name: string
          updated_at: string | null
        }
        Insert: {
          created_at?: string
          email_domain: string
          id?: string
          logo_media?: Json | null
          name: string
          updated_at?: string | null
        }
        Update: {
          created_at?: string
          email_domain?: string
          id?: string
          logo_media?: Json | null
          name?: string
          updated_at?: string | null
        }
        Relationships: []
      }
      promotions: {
        Row: {
          available_from: string | null
          available_to: string | null
          created_at: string
          deactivated_at: string | null
          id: string
          max_activations: number | null
          promotion_amount: number
          promotion_code: string
          promotion_data: Json | null
          promotion_type: string
          title_key: string
          updated_at: string
          valid_duration: string | null
          valid_for_products: string[] | null
        }
        Insert: {
          available_from?: string | null
          available_to?: string | null
          created_at?: string
          deactivated_at?: string | null
          id?: string
          max_activations?: number | null
          promotion_amount: number
          promotion_code: string
          promotion_data?: Json | null
          promotion_type: string
          title_key: string
          updated_at?: string
          valid_duration?: string | null
          valid_for_products?: string[] | null
        }
        Update: {
          available_from?: string | null
          available_to?: string | null
          created_at?: string
          deactivated_at?: string | null
          id?: string
          max_activations?: number | null
          promotion_amount?: number
          promotion_code?: string
          promotion_data?: Json | null
          promotion_type?: string
          title_key?: string
          updated_at?: string
          valid_duration?: string | null
          valid_for_products?: string[] | null
        }
        Relationships: []
      }
      trait_assignments: {
        Row: {
          assignment_type: Database["public"]["Enums"]["trait_assignment_type_enum"]
          created_at: string | null
          created_by: string | null
          disposition: Database["public"]["Enums"]["trait_disposition"]
          id: string
          object_id: string
          object_type: Database["public"]["Enums"]["trait_object_type"]
          trait_id: string
        }
        Insert: {
          assignment_type?: Database["public"]["Enums"]["trait_assignment_type_enum"]
          created_at?: string | null
          created_by?: string | null
          disposition?: Database["public"]["Enums"]["trait_disposition"]
          id?: string
          object_id: string
          object_type?: Database["public"]["Enums"]["trait_object_type"]
          trait_id: string
        }
        Update: {
          assignment_type?: Database["public"]["Enums"]["trait_assignment_type_enum"]
          created_at?: string | null
          created_by?: string | null
          disposition?: Database["public"]["Enums"]["trait_disposition"]
          id?: string
          object_id?: string
          object_type?: Database["public"]["Enums"]["trait_object_type"]
          trait_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "trait_assignments_trait_id_fkey"
            columns: ["trait_id"]
            isOneToOne: false
            referencedRelation: "asset_traits"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "trait_assignments_trait_id_fkey"
            columns: ["trait_id"]
            isOneToOne: false
            referencedRelation: "interest_traits"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "trait_assignments_trait_id_fkey"
            columns: ["trait_id"]
            isOneToOne: false
            referencedRelation: "trait_assignment_counts"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "trait_assignments_trait_id_fkey"
            columns: ["trait_id"]
            isOneToOne: false
            referencedRelation: "traits"
            referencedColumns: ["id"]
          },
        ]
      }
      traits: {
        Row: {
          created_at: string
          created_by: string | null
          embedding: string | null
          id: string
          popularity_boost: number | null
          realm: Database["public"]["Enums"]["trait_realm"]
          region: string | null
          text: string
          text_vector: unknown
          translations: Json | null
          unique_category: string | null
        }
        Insert: {
          created_at?: string
          created_by?: string | null
          embedding?: string | null
          id?: string
          popularity_boost?: number | null
          realm?: Database["public"]["Enums"]["trait_realm"]
          region?: string | null
          text: string
          text_vector?: unknown
          translations?: Json | null
          unique_category?: string | null
        }
        Update: {
          created_at?: string
          created_by?: string | null
          embedding?: string | null
          id?: string
          popularity_boost?: number | null
          realm?: Database["public"]["Enums"]["trait_realm"]
          region?: string | null
          text?: string
          text_vector?: unknown
          translations?: Json | null
          unique_category?: string | null
        }
        Relationships: []
      }
      user_feed_items: {
        Row: {
          created_at: string
          event_id: string
          feed_added_at: string
          feed_seen_at: string | null
          id: string
          item_context: string
          item_id: string
          item_type: string
          user_id: string
        }
        Insert: {
          created_at?: string
          event_id: string
          feed_added_at?: string
          feed_seen_at?: string | null
          id?: string
          item_context: string
          item_id: string
          item_type: string
          user_id: string
        }
        Update: {
          created_at?: string
          event_id?: string
          feed_added_at?: string
          feed_seen_at?: string | null
          id?: string
          item_context?: string
          item_id?: string
          item_type?: string
          user_id?: string
        }
        Relationships: []
      }
      user_inbound_addresses: {
        Row: {
          created_at: string
          email_name: string
          user_id: string
        }
        Insert: {
          created_at?: string
          email_name: string
          user_id: string
        }
        Update: {
          created_at?: string
          email_name?: string
          user_id?: string
        }
        Relationships: []
      }
      user_invitations: {
        Row: {
          created_at: string
          email: string
          id: string
          inviter_name: string | null
          inviter_user_id: string | null
          phone: string | null
          updated_at: string
          user_id: string | null
        }
        Insert: {
          created_at?: string
          email: string
          id?: string
          inviter_name?: string | null
          inviter_user_id?: string | null
          phone?: string | null
          updated_at?: string
          user_id?: string | null
        }
        Update: {
          created_at?: string
          email?: string
          id?: string
          inviter_name?: string | null
          inviter_user_id?: string | null
          phone?: string | null
          updated_at?: string
          user_id?: string | null
        }
        Relationships: []
      }
      user_profile: {
        Row: {
          created_at: string
          data: Json | null
          id: string
          name: string
          slug: string | null
          updated_at: string | null
          user_id: string
        }
        Insert: {
          created_at?: string
          data?: Json | null
          id?: string
          name: string
          slug?: string | null
          updated_at?: string | null
          user_id?: string
        }
        Update: {
          created_at?: string
          data?: Json | null
          id?: string
          name?: string
          slug?: string | null
          updated_at?: string | null
          user_id?: string
        }
        Relationships: []
      }
      user_roles: {
        Row: {
          created_at: string
          id: string
          role: Database["public"]["Enums"]["user_role"]
          user_id: string
        }
        Insert: {
          created_at?: string
          id?: string
          role?: Database["public"]["Enums"]["user_role"]
          user_id?: string
        }
        Update: {
          created_at?: string
          id?: string
          role?: Database["public"]["Enums"]["user_role"]
          user_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "user_roles_user_id_fkey"
            columns: ["user_id"]
            isOneToOne: false
            referencedRelation: "user_profile"
            referencedColumns: ["user_id"]
          },
        ]
      }
      users_assets: {
        Row: {
          asset_id: string
          created_at: string
          data: Json | null
          id: string
          relation_type: Database["public"]["Enums"]["user_asset_relation"]
          updated_at: string
          user_id: string
          is_own: boolean | null
        }
        Insert: {
          asset_id: string
          created_at?: string
          data?: Json | null
          id?: string
          relation_type?: Database["public"]["Enums"]["user_asset_relation"]
          updated_at?: string
          user_id?: string
        }
        Update: {
          asset_id?: string
          created_at?: string
          data?: Json | null
          id?: string
          relation_type?: Database["public"]["Enums"]["user_asset_relation"]
          updated_at?: string
          user_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "users_assets_asset_id_fkey"
            columns: ["asset_id"]
            isOneToOne: false
            referencedRelation: "asset_addresses"
            referencedColumns: ["asset_id"]
          },
          {
            foreignKeyName: "users_assets_asset_id_fkey"
            columns: ["asset_id"]
            isOneToOne: false
            referencedRelation: "asset_traits"
            referencedColumns: ["asset_id"]
          },
          {
            foreignKeyName: "users_assets_asset_id_fkey"
            columns: ["asset_id"]
            isOneToOne: false
            referencedRelation: "assets"
            referencedColumns: ["id"]
          },
        ]
      }
    }
    Views: {
      asset_addresses: {
        Row: {
          address: Json | null
          address_created_at: string | null
          address_id: string | null
          asset_id: string | null
          connected_at: string | null
          connection_id: string | null
          country: string | null
          data: Json | null
          geom: unknown
          postal_code: string | null
          relation_type:
            | Database["public"]["Enums"]["address_relation_type"]
            | null
        }
        Relationships: []
      }
      asset_traits: {
        Row: {
          asset_id: string | null
          assignment_id: string | null
          assignment_type:
            | Database["public"]["Enums"]["trait_assignment_type_enum"]
            | null
          created_at: string | null
          created_by: string | null
          disposition: Database["public"]["Enums"]["trait_disposition"] | null
          id: string | null
          popularity_boost: number | null
          realm: Database["public"]["Enums"]["trait_realm"] | null
          region: string | null
          text: string | null
          translations: Json | null
          unique_category: string | null
        }
        Relationships: []
      }
      interest_traits: {
        Row: {
          assignment_id: string | null
          assignment_type:
            | Database["public"]["Enums"]["trait_assignment_type_enum"]
            | null
          created_at: string | null
          created_by: string | null
          disposition: Database["public"]["Enums"]["trait_disposition"] | null
          id: string | null
          interest_id: string | null
          popularity_boost: number | null
          realm: Database["public"]["Enums"]["trait_realm"] | null
          region: string | null
          text: string | null
          translations: Json | null
          unique_category: string | null
        }
        Relationships: []
      }
      trait_assignment_counts: {
        Row: {
          asset_assignments: number | null
          id: string | null
        }
        Relationships: []
      }
    }
    Functions: {
      address_hash: { Args: { addr: Json }; Returns: string }
      address_stats: {
        Args: { addr: Json; lat: number; lng: number }
        Returns: undefined
      }
      asset_addresses: {
        Args: { assets: Database["public"]["Tables"]["assets"]["Row"] }
        Returns: {
          address: Json | null
          address_created_at: string | null
          address_id: string | null
          asset_id: string | null
          connected_at: string | null
          connection_id: string | null
          country: string | null
          data: Json | null
          geom: unknown
          postal_code: string | null
          relation_type:
            | Database["public"]["Enums"]["address_relation_type"]
            | null
        }[]
        SetofOptions: {
          from: "assets"
          to: "asset_addresses"
          isOneToOne: false
          isSetofReturn: true
        }
      }
      asset_traits: {
        Args: { assets: Database["public"]["Tables"]["assets"]["Row"] }
        Returns: {
          asset_id: string | null
          assignment_id: string | null
          assignment_type:
            | Database["public"]["Enums"]["trait_assignment_type_enum"]
            | null
          created_at: string | null
          created_by: string | null
          disposition: Database["public"]["Enums"]["trait_disposition"] | null
          id: string | null
          popularity_boost: number | null
          realm: Database["public"]["Enums"]["trait_realm"] | null
          region: string | null
          text: string | null
          translations: Json | null
          unique_category: string | null
        }[]
        SetofOptions: {
          from: "assets"
          to: "asset_traits"
          isOneToOne: false
          isSetofReturn: true
        }
      }
      build_interest_locations_geom: {
        Args: { interest_data_param: Json }
        Returns: unknown
      }
      calculate_asset_interest_match: {
        Args: {
          asset_id_param: string
          interest_id_param: string
          sub_threshold_param?: number
          threshold_param?: number
        }
        Returns: {
          asset_id: string
          building_type_score: number
          location_score: number
          match_score: number
          other_score: number
          price_score: number
          size_score: number
        }[]
      }
      calculate_asset_interest_traits_similarity: {
        Args: { asset_id: string; interest_id: string }
        Returns: number
      }
      calculate_asset_traits_similarity: {
        Args: { asset_id: string; p_trait_texts: string[] }
        Returns: number
      }
      calculate_match_scores: {
        Args: {
          allow_partial?: boolean
          asset_country: string
          asset_data: Json
          asset_geom: unknown
          asset_postal_code: string
          interest_data: Json
          is_estimated_price?: boolean
        }
        Returns: {
          building_type_score: number
          location_score: number
          match_score: number
          other_score: number
          price_score: number
          size_score: number
        }[]
      }
      can_request_contact: {
        Args: {
          lead_contact_id: string
          offer_asset_id: string
          query_user_id: string
        }
        Returns: boolean
      }
      deduplicate_addresses: { Args: never; Returns: number }
      find_similar_traits: {
        Args: {
          max_results?: number
          p_realm?: Database["public"]["Enums"]["trait_realm"]
          similarity_threshold?: number
          trait_id: string
        }
        Returns: {
          id: string
          realm: Database["public"]["Enums"]["trait_realm"]
          similarity: number
          text: string
          translations: Json
          unique_category: string
        }[]
      }
      generate_short_id: { Args: { length?: number }; Returns: string }
      get_asset_feed: {
        Args: {
          p_cursor_added_at?: string
          p_cursor_id?: string
          p_limit?: number
          p_only_new?: boolean
          p_user_id: string
        }
        Returns: {
          asset_address: Json
          asset_data: Json
          asset_id: string
          asset_media: Json
          asset_name: string
          asset_prices: Json
          feed_added_at: string
          feed_event_ids: string[]
          feedback_responses: Json
          is_new: boolean
          is_own: boolean
          matching_leads: Json
          organisation_id: string
          organisation_logo: Json
          organisation_name: string
          realtor_count: number
          realtor_name: string
          relation_type: string
          total_feedback_responses_count: number
          total_matching_leads_count: number
        }[]
      }
      get_asset_feed_count: {
        Args: { p_only_new?: boolean; p_user_id: string }
        Returns: number
      }
      get_asset_matches_for_interest: {
        Args: {
          cursor_id?: string
          cursor_match_score?: number
          cursor_updated_at?: string
          interest_id_param: string
          limit_param?: number
          sub_threshold_param?: number
          threshold_param?: number
          user_id_param: string
        }
        Returns: {
          address: Json
          address_id: string
          all_asset_ids: string[]
          building_type_score: number
          created_at: string
          data: Json
          description: string
          geom: unknown
          id: string
          is_own: boolean
          location_score: number
          match_count: number
          match_score: number
          media: Json
          name: string
          organisation_id: string
          organisation_logo: Json
          organisation_name: string
          other_score: number
          price_score: number
          prices: Json
          realtor_count: number
          realtor_name: string
          relation_type: Database["public"]["Enums"]["user_asset_relation"]
          size_score: number
          source: Json
          total_count: number
          updated_at: string
        }[]
      }
      get_asset_owners_matching_interest: {
        Args: {
          p_interest_id: string
          p_limit_per_user?: number
          p_sub_threshold?: number
          p_threshold?: number
        }
        Returns: {
          asset_ids: string[]
          asset_owner_id: string
        }[]
      }
      get_asset_trait_embeddings: {
        Args: { asset_id: string }
        Returns: {
          embedding: string
          id: string
        }[]
      }
      get_best_lead_matches_for_asset: {
        Args: {
          p_asset_id: string
          p_limit?: number
          p_sub_threshold?: number
          p_threshold?: number
          p_user_id: string
        }
        Returns: {
          asset_match: Json
          interest_data: Json
          interest_id: string
          lead_asset_media: Json
          lead_created_at: string
          lead_id: string
          lead_name: string
          organisation_id: string
          organisation_logo: Json
          organisation_name: string
          realtor_name: string
          verified_at: string
        }[]
      }
      get_deduplicated_leads: {
        Args: { ownership_filter?: string; query_user_id: string }
        Returns: {
          contact_ids: string[]
          created_at: string
          id: string
          interest_created_at: string
          interest_data: Json
          interest_id: string
          is_own: boolean
          is_purchased: boolean
          language: string
          media: Json
          name: string
          organisation_id: string
          organisation_logo: Json
          organisation_name: string
          realtor_name: string
          updated_at: string
          verified_at: string
        }[]
      }
      get_interest_trait_embeddings: {
        Args: { interest_id: string }
        Returns: {
          embedding: string
          id: string
        }[]
      }
      get_lead: {
        Args: { lead_contact_id: string; query_user_id: string }
        Returns: {
          consent_confirmed: boolean
          contact_ids: string[]
          created_at: string
          disabled_at: string
          disabled_reason: string
          email: string
          feedback_intelligence: Json
          id: string
          interests: Json
          is_own: boolean
          is_purchased: boolean
          language: string
          name: string
          organisation_id: string
          organisation_logo: Json
          organisation_name: string
          owned_contact_id: string
          phone: string
          private_data: Json
          realtor_name: string
          updated_at: string
          verified_at: string
        }[]
      }
      get_lead_feed: {
        Args: {
          p_cursor_added_at?: string
          p_cursor_id?: string
          p_limit?: number
          p_only_new?: boolean
          p_user_id: string
        }
        Returns: {
          contact_ids: string[]
          feed_added_at: string
          feed_event_ids: string[]
          feedback_responses: Json
          interest_data: Json
          interest_id: string
          is_interest_new: boolean
          is_new: boolean
          is_own: boolean
          is_purchased: boolean
          is_verified: boolean
          lead_email: string
          lead_id: string
          lead_name: string
          lead_phone: string
          matching_assets: Json
          organisation_id: string
          organisation_logo: Json
          organisation_name: string
          realtor_name: string
          total_feedback_responses_count: number
          total_matching_assets_count: number
        }[]
      }
      get_lead_feed_count: {
        Args: { p_only_new?: boolean; p_user_id: string }
        Returns: number
      }
      get_lead_origin_candidates: {
        Args: { query_user_id: string }
        Returns: {
          origin_contact_id: string
        }[]
      }
      get_lead_owner: { Args: { p_lead_id: string }; Returns: string }
      get_lead_owners_with_asset_access: {
        Args: {
          p_asset_id: string
          p_asset_owner_id: string
          p_sub_threshold?: number
          p_threshold?: number
        }
        Returns: {
          interest_id: string
          lead_contact_id: string
          lead_owner_id: string
        }[]
      }
      get_leads_for_asset: {
        Args: {
          p_asset_id: string
          p_cursor_created_at?: string
          p_cursor_id?: string
          p_cursor_interest_created_at?: string
          p_cursor_match_score?: number
          p_include_marketplace?: boolean
          p_limit?: number
          p_sub_threshold?: number
          p_threshold?: number
          p_user_id: string
        }
        Returns: {
          building_type_score: number
          contact_ids: string[]
          created_at: string
          feedback_answers: Json
          interest_created_at: string
          interest_data: Json
          interest_id: string
          is_own: boolean
          is_purchased: boolean
          language: string
          lead_id: string
          location_score: number
          match_count: number
          match_score: number
          name: string
          organisation_id: string
          organisation_logo: Json
          organisation_name: string
          other_score: number
          price_score: number
          realtor_name: string
          size_score: number
          total_count: number
          updated_at: string
          verified_at: string
        }[]
      }
      get_leads_matches_for_asset: {
        Args: {
          cursor_created_at?: string
          cursor_id?: string
          cursor_interest_created_at?: string
          cursor_match_score?: number
          limit_param?: number
          match_asset_id?: string
          ownership_filter?: string
          query_user_id: string
          sub_threshold_param?: number
          threshold_param?: number
        }
        Returns: {
          building_type_score: number
          contact_ids: string[]
          created_at: string
          id: string
          interest_created_at: string
          interest_data: Json
          interest_id: string
          is_own: boolean
          is_purchased: boolean
          language: string
          location_score: number
          match_score: number
          media: Json
          name: string
          organisation_id: string
          organisation_logo: Json
          organisation_name: string
          other_score: number
          price_score: number
          realtor_name: string
          size_score: number
          total_count: number
          updated_at: string
          verified_at: string
        }[]
      }
      get_leads_matches_for_asset_data: {
        Args: {
          allow_partial?: boolean
          asset_data?: Json
          asset_locations?: Json
          cursor_created_at?: string
          cursor_id?: string
          cursor_interest_created_at?: string
          cursor_match_score?: number
          limit_param?: number
          ownership_filter?: string
          query_user_id: string
        }
        Returns: {
          building_type_score: number
          contact_ids: string[]
          created_at: string
          id: string
          interest_created_at: string
          interest_data: Json
          interest_id: string
          is_own: boolean
          is_purchased: boolean
          language: string
          location_score: number
          match_score: number
          media: Json
          name: string
          organisation_id: string
          organisation_logo: Json
          organisation_name: string
          other_score: number
          price_score: number
          realtor_name: string
          size_score: number
          total_count: number
          updated_at: string
          verified_at: string
        }[]
      }
      get_leads_with_newest_interest_for_users: {
        Args: { p_user_ids: string[] }
        Returns: {
          interest_id: string
          lead_contact_id: string
          lead_owner_id: string
        }[]
      }
      get_leads_with_top_asset_matches: {
        Args: {
          cursor_created_at?: string
          cursor_id?: string
          limit_param?: number
          ownership_filter?: string
          query_user_id: string
          sub_threshold_param?: number
          threshold_param?: number
          top_assets_limit?: number
        }
        Returns: {
          contact_ids: string[]
          created_at: string
          id: string
          interest_created_at: string
          interest_data: Json
          interest_id: string
          is_own: boolean
          is_purchased: boolean
          language: string
          media: Json
          name: string
          organisation_id: string
          organisation_logo: Json
          organisation_name: string
          realtor_name: string
          top_matching_assets: Json
          total_count: number
          updated_at: string
          verified_at: string
        }[]
      }
      get_organisation_users: {
        Args: { p_organisation_id: string }
        Returns: {
          created_at: string
          data: Json
          email: string
          name: string
          profile_id: string
          slug: string
          user_id: string
        }[]
      }
      get_organization_asset: {
        Args: { query_user_id: string; target_asset_id: string }
        Returns: {
          address: Json
          address_id: string
          created_at: string
          data: Json
          description: string
          geom: unknown
          id: string
          is_own: boolean
          media: Json
          name: string
          organisation_id: string
          organisation_logo: Json
          organisation_name: string
          prices: Json
          realtor_data: Json
          realtor_name: string
          realtor_slug: string
          relation_data: Json
          relation_id: string
          relation_type: Database["public"]["Enums"]["user_asset_relation"]
          source: Json
          updated_at: string
          user_id: string
        }[]
      }
      get_organization_assets: {
        Args: {
          cursor_id?: string
          cursor_updated_at?: string
          include_organization?: boolean
          limit_param?: number
          query_user_id: string
          relation_type_filter?: Database["public"]["Enums"]["user_asset_relation"]
        }
        Returns: {
          address: Json
          address_id: string
          all_asset_ids: string[]
          created_at: string
          data: Json
          description: string
          geom: unknown
          id: string
          is_own: boolean
          media: Json
          name: string
          organisation_id: string
          organisation_logo: Json
          organisation_name: string
          prices: Json
          realtor_count: number
          realtor_name: string
          relation_type: Database["public"]["Enums"]["user_asset_relation"]
          source: Json
          total_count: number
          updated_at: string
        }[]
      }
      get_resolved_lead_group: {
        Args: { origin_contact_id: string; query_user_id: string }
        Returns: {
          consent_confirmed: boolean
          contact_ids: string[]
          disabled_at: string
          disabled_reason: string
          email: string
          first_created_at: string
          group_id: string
          has_any_interest: boolean
          is_own: boolean
          is_purchased: boolean
          language: string
          last_updated_at: string
          name: string
          phone: string
          primary_contact_id: string
          user_own_contact_id: string
          user_purchased_contact_id: string
        }[]
      }
      get_significant_object_traits: {
        Args: { p_object_id: string }
        Returns: {
          created_at: string
          id: string
          popularity_boost: number
          realm: Database["public"]["Enums"]["trait_realm"]
          text: string
          translations: Json
          unique_category: string
        }[]
      }
      get_trait_searchable_text: {
        Args: { trait_text: string; translations: Json }
        Returns: string
      }
      get_translation_texts: { Args: { translations: Json }; Returns: string[] }
      get_user_lead_groups: {
        Args: { filter_contact_id?: string; query_user_id: string }
        Returns: {
          consent_confirmed: boolean
          contact_ids: string[]
          disabled_at: string
          disabled_reason: string
          email: string
          first_created_at: string
          group_id: string
          has_any_interest: boolean
          is_own: boolean
          is_purchased: boolean
          language: string
          last_updated_at: string
          name: string
          phone: string
          primary_contact_id: string
          user_own_contact_id: string
          user_purchased_contact_id: string
        }[]
      }
      get_user_organisation: {
        Args: { p_user_id: string }
        Returns: {
          created_at: string
          email_domain: string
          id: string
          logo_media: Json
          name: string
          updated_at: string
        }[]
      }
      get_user_owned_leads: {
        Args: { p_user_id: string }
        Returns: {
          contact_ids: string[]
          created_at: string
          id: string
          interest_created_at: string
          interest_data: Json
          interest_id: string
          is_own: boolean
          is_purchased: boolean
          language: string
          media: Json
          name: string
          organisation_id: string
          organisation_logo: Json
          organisation_name: string
          realtor_name: string
          updated_at: string
          verified_at: string
        }[]
      }
      interest_traits: {
        Args: { interests: Database["public"]["Tables"]["interests"]["Row"] }
        Returns: {
          assignment_id: string | null
          assignment_type:
            | Database["public"]["Enums"]["trait_assignment_type_enum"]
            | null
          created_at: string | null
          created_by: string | null
          disposition: Database["public"]["Enums"]["trait_disposition"] | null
          id: string | null
          interest_id: string | null
          popularity_boost: number | null
          realm: Database["public"]["Enums"]["trait_realm"] | null
          region: string | null
          text: string | null
          translations: Json | null
          unique_category: string | null
        }[]
        SetofOptions: {
          from: "interests"
          to: "interest_traits"
          isOneToOne: false
          isSetofReturn: true
        }
      }
      is_own: {
        Args: { "": Database["public"]["Tables"]["users_assets"]["Row"] }
        Returns: {
          error: true
        } & "the function public.is_own with parameter or with a single unnamed json/jsonb parameter, but no matches were found in the schema cache"
      }
      mark_feed_event_seen: { Args: { p_event_id: string }; Returns: undefined }
      mark_feed_item_seen: {
        Args: { p_feed_item_id: string }
        Returns: undefined
      }
      match_trait_embeddings: {
        Args: { search_trait_ids: string[]; target_trait_ids: string[] }
        Returns: number
      }
      normalize_contact_email: { Args: { value: string }; Returns: string }
      normalize_contact_phone: { Args: { value: string }; Returns: string }
      popular_traits_by_address: {
        Args: {
          cursor_id?: string
          exclude_assigned_to_object_id?: string
          exclude_categories?: string[]
          min_assignments?: number
          p_disposition?: Database["public"]["Enums"]["trait_disposition"]
          p_object_type?: string
          p_realm?: Database["public"]["Enums"]["trait_realm"]
          page_size?: number
          query_address: Json
        }
        Returns: {
          assignments: number
          created_at: string
          disposition: Database["public"]["Enums"]["trait_disposition"]
          id: string
          popularity: number
          realm: Database["public"]["Enums"]["trait_realm"]
          text: string
          translations: Json
          unique_category: string
        }[]
      }
      prepopulate_user_feed: {
        Args: {
          p_match_threshold?: number
          p_sub_match_threshold?: number
          p_user_id: string
        }
        Returns: Json
      }
      push_feed_item: {
        Args: {
          p_created_at?: string
          p_event_id: string
          p_item_context: string
          p_item_id: string
          p_item_type: string
          p_user_id: string
        }
        Returns: undefined
      }
      push_feed_items: { Args: { p_items: Json }; Returns: undefined }
      score_building_type: {
        Args: { asset_type: string; interest_types: string[] }
        Returns: number
      }
      score_location: {
        Args: {
          asset_country: string
          asset_geom: unknown
          asset_postal_code: string
          interest_locations: Json
        }
        Returns: number
      }
      score_other_factors: {
        Args: {
          asset_build_year: number
          asset_condition: string
          asset_rooms: number
          interest_filters: Json
        }
        Returns: number
      }
      score_price: {
        Args: {
          asset_price: number
          is_estimated_price?: boolean
          price_max: number
          price_min: number
        }
        Returns: number
      }
      score_size: {
        Args: { asset_size: number; size_max: number; size_min: number }
        Returns: number
      }
      search_traits: {
        Args: {
          embedding_vector?: string
          max_results?: number
          p_disposition?: Database["public"]["Enums"]["trait_disposition"]
          p_realm?: Database["public"]["Enums"]["trait_realm"]
          search_query: string
          text_weight?: number
          vector_similarity_threshold?: number
          vector_weight?: number
        }
        Returns: {
          assignments: number
          created_at: string
          disposition: Database["public"]["Enums"]["trait_disposition"]
          id: string
          realm: Database["public"]["Enums"]["trait_realm"]
          similarity: number
          text: string
          translations: Json
          unique_category: string
        }[]
      }
    }
    Enums: {
      address_relation_type: "primary"
      asset_price_type:
        | "asking_rent"
        | "asking_price"
        | "final_rent"
        | "final_price"
        | "offer_rent"
        | "offer_price"
        | "estimated_price"
      contact_request_status: "pending" | "accepted" | "rejected"
      trait_assignment_type_enum: "assigned" | "suggested"
      trait_disposition: "positive" | "negative" | "neutral"
      trait_object_type: "asset" | "interest"
      trait_realm: "real_estate" | "realtor"
      user_asset_relation: "representation" | "reference" | "prospect"
      user_role: "realtor" | "buyer" | "seller"
    }
    CompositeTypes: {
      asset_match_score: {
        asset_id: string | null
        match_score: number | null
        price_score: number | null
        location_score: number | null
        size_score: number | null
        building_type_score: number | null
        other_score: number | null
      }
    }
  }
  secure: {
    Tables: {
      admins: {
        Row: {
          user_id: string
        }
        Insert: {
          user_id: string
        }
        Update: {
          user_id?: string
        }
        Relationships: []
      }
      documents_ocr_results: {
        Row: {
          created_at: string
          data: Json | null
          hash: string
          images: Json | null
          markdown_content: string | null
        }
        Insert: {
          created_at?: string
          data?: Json | null
          hash: string
          images?: Json | null
          markdown_content?: string | null
        }
        Update: {
          created_at?: string
          data?: Json | null
          hash?: string
          images?: Json | null
          markdown_content?: string | null
        }
        Relationships: []
      }
    }
    Views: {
      contact_lead_facts: {
        Row: {
          consent_confirmed: boolean | null
          contact_id: string | null
          created_at: string | null
          disabled_at: string | null
          disabled_reason: string | null
          email: string | null
          email_key: string | null
          has_any_interest: boolean | null
          has_identifier: boolean | null
          has_verified_interest: boolean | null
          is_inactive: boolean | null
          language: string | null
          latest_any_interest_created_at: string | null
          latest_verified_interest_created_at: string | null
          name: string | null
          phone: string | null
          phone_key: string | null
          private_data: Json | null
          purchased_at: string | null
          updated_at: string | null
          user_id: string | null
        }
        Relationships: []
      }
    }
    Functions: {
      check_user_identifier_exists: {
        Args: { email_or_phone: string }
        Returns: {
          id: string
        }[]
      }
    }
    Enums: {
      [_ in never]: never
    }
    CompositeTypes: {
      [_ in never]: never
    }
  }
}

type DatabaseWithoutInternals = Omit<Database, "__InternalSupabase">

type DefaultSchema = DatabaseWithoutInternals[Extract<keyof Database, "public">]

export type Tables<
  DefaultSchemaTableNameOrOptions extends
    | keyof (DefaultSchema["Tables"] & DefaultSchema["Views"])
    | { schema: keyof DatabaseWithoutInternals },
  TableName extends DefaultSchemaTableNameOrOptions extends {
    schema: keyof DatabaseWithoutInternals
  }
    ? keyof (DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Tables"] &
        DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Views"])
    : never = never,
> = DefaultSchemaTableNameOrOptions extends {
  schema: keyof DatabaseWithoutInternals
}
  ? (DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Tables"] &
      DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Views"])[TableName] extends {
      Row: infer R
    }
    ? R
    : never
  : DefaultSchemaTableNameOrOptions extends keyof (DefaultSchema["Tables"] &
        DefaultSchema["Views"])
    ? (DefaultSchema["Tables"] &
        DefaultSchema["Views"])[DefaultSchemaTableNameOrOptions] extends {
        Row: infer R
      }
      ? R
      : never
    : never

export type TablesInsert<
  DefaultSchemaTableNameOrOptions extends
    | keyof DefaultSchema["Tables"]
    | { schema: keyof DatabaseWithoutInternals },
  TableName extends DefaultSchemaTableNameOrOptions extends {
    schema: keyof DatabaseWithoutInternals
  }
    ? keyof DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Tables"]
    : never = never,
> = DefaultSchemaTableNameOrOptions extends {
  schema: keyof DatabaseWithoutInternals
}
  ? DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Tables"][TableName] extends {
      Insert: infer I
    }
    ? I
    : never
  : DefaultSchemaTableNameOrOptions extends keyof DefaultSchema["Tables"]
    ? DefaultSchema["Tables"][DefaultSchemaTableNameOrOptions] extends {
        Insert: infer I
      }
      ? I
      : never
    : never

export type TablesUpdate<
  DefaultSchemaTableNameOrOptions extends
    | keyof DefaultSchema["Tables"]
    | { schema: keyof DatabaseWithoutInternals },
  TableName extends DefaultSchemaTableNameOrOptions extends {
    schema: keyof DatabaseWithoutInternals
  }
    ? keyof DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Tables"]
    : never = never,
> = DefaultSchemaTableNameOrOptions extends {
  schema: keyof DatabaseWithoutInternals
}
  ? DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Tables"][TableName] extends {
      Update: infer U
    }
    ? U
    : never
  : DefaultSchemaTableNameOrOptions extends keyof DefaultSchema["Tables"]
    ? DefaultSchema["Tables"][DefaultSchemaTableNameOrOptions] extends {
        Update: infer U
      }
      ? U
      : never
    : never

export type Enums<
  DefaultSchemaEnumNameOrOptions extends
    | keyof DefaultSchema["Enums"]
    | { schema: keyof DatabaseWithoutInternals },
  EnumName extends DefaultSchemaEnumNameOrOptions extends {
    schema: keyof DatabaseWithoutInternals
  }
    ? keyof DatabaseWithoutInternals[DefaultSchemaEnumNameOrOptions["schema"]]["Enums"]
    : never = never,
> = DefaultSchemaEnumNameOrOptions extends {
  schema: keyof DatabaseWithoutInternals
}
  ? DatabaseWithoutInternals[DefaultSchemaEnumNameOrOptions["schema"]]["Enums"][EnumName]
  : DefaultSchemaEnumNameOrOptions extends keyof DefaultSchema["Enums"]
    ? DefaultSchema["Enums"][DefaultSchemaEnumNameOrOptions]
    : never

export type CompositeTypes<
  PublicCompositeTypeNameOrOptions extends
    | keyof DefaultSchema["CompositeTypes"]
    | { schema: keyof DatabaseWithoutInternals },
  CompositeTypeName extends PublicCompositeTypeNameOrOptions extends {
    schema: keyof DatabaseWithoutInternals
  }
    ? keyof DatabaseWithoutInternals[PublicCompositeTypeNameOrOptions["schema"]]["CompositeTypes"]
    : never = never,
> = PublicCompositeTypeNameOrOptions extends {
  schema: keyof DatabaseWithoutInternals
}
  ? DatabaseWithoutInternals[PublicCompositeTypeNameOrOptions["schema"]]["CompositeTypes"][CompositeTypeName]
  : PublicCompositeTypeNameOrOptions extends keyof DefaultSchema["CompositeTypes"]
    ? DefaultSchema["CompositeTypes"][PublicCompositeTypeNameOrOptions]
    : never

export const Constants = {
  public: {
    Enums: {
      address_relation_type: ["primary"],
      asset_price_type: [
        "asking_rent",
        "asking_price",
        "final_rent",
        "final_price",
        "offer_rent",
        "offer_price",
        "estimated_price",
      ],
      contact_request_status: ["pending", "accepted", "rejected"],
      trait_assignment_type_enum: ["assigned", "suggested"],
      trait_disposition: ["positive", "negative", "neutral"],
      trait_object_type: ["asset", "interest"],
      trait_realm: ["real_estate", "realtor"],
      user_asset_relation: ["representation", "reference", "prospect"],
      user_role: ["realtor", "buyer", "seller"],
    },
  },
  secure: {
    Enums: {},
  },
} as const

